module.exports = __webpack_public_path__ + "static/02-e3c89137789c02610337da31a66b46b7.jpg";